<div class="view-container">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

        <mat-card *ngIf="fullCatalogAccess || isSituUser" [fxFlex]="fullCatalogAccess || isSituUser ? '50' : '100'" class="contrast">
          <mat-card-content>
            <form>
              <mat-form-field>
                <input matInput type="text" placeholder="Filter by Company" matInput [formControl]="companyControl" [matAutocomplete]="companyAuto">
                <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="onCompanySelected($event)">
                  <mat-option *ngFor="let company of filteredCompanies | async" [value]="company.name">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <img class="company-logo" *ngIf="company?.logoUrl" [lazyLoad]="company.logoUrl" [matTooltip]="company.name" />
                        <span [innerHtml]="company.name | highlight: companyControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
                <button mat-button *ngIf="companyNameFilter" matSuffix mat-icon-button aria-label="Clear" (click)="onClearCompany()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </form>
          </mat-card-content>
        </mat-card>

        <mat-card fxFlex="50" class="contrast">
          <mat-card-content>
            <form>
              <mat-form-field>
                <input matInput type="text" placeholder="Show Shared Range" matInput [formControl]="productRangeControl" [matAutocomplete]="productRangeAuto">
                <mat-autocomplete #productRangeAuto="matAutocomplete" (optionSelected)="onProductRangeSelected($event)" [displayWith]="displayRange">
                  <mat-option *ngFor="let item of filteredProductRanges | async" [value]="item">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <img class="company-logo" *ngIf="getCompanyLogo(item?.companyId)" [lazyLoad]="getCompanyLogo(item?.companyId)" [matTooltip]="getCompanyName(item?.companyId)" />
                        <span *ngIf="!getCompanyLogo(item?.companyId)">{{ getCompanyName(item?.companyId) }}</span>
                        <span class="text-info" [innerHtml]="item.name | highlight: productRangeControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
                <button mat-button *ngIf="rangeIdFilter" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductRange()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </form>
          </mat-card-content>
        </mat-card>

        <mat-card [fxFlex]="fullCatalogAccess || isSituUser ? '50' : '100'" class="contrast">
          <mat-card-content>
            <form>
              <mat-form-field>
                <input matInput type="text" placeholder="Filter by Product Type" matInput [formControl]="productTypeControl" [matAutocomplete]="productTypeAuto">
                <button mat-button *ngIf="productTypeNameFilter" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductType()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onProductTypeSelected($event)">
                  <mat-option *ngFor="let productType of filteredProductTypes | async" [value]="productType.name">
                      <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <div class="product-type-dropdown-indicator" [style.background-color]="productType?.color" matTooltip="Product Type"></div>
                        <span [innerHtml]="productType.name | highlight: productTypeControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </form>
          </mat-card-content>
        </mat-card>
        
        <mat-card *ngIf="productStateAccess" fxFlex="50" class="contrast">
          <mat-card-content>
            <form>
              <mat-form-field>
                <input matInput type="text" placeholder="Filter by Product State" matInput [formControl]="productStateControl" [matAutocomplete]="productStateAuto">
                <button mat-button *ngIf="productStateNameFilter" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductState()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #productStateAuto="matAutocomplete" (optionSelected)="onProductStateSelected($event)">
                  <mat-option *ngFor="let productState of filteredProductStates | async" [value]="productState.name">
                      <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <product-workflow-icon id="workflow-state-list-icon"
                          [workflowStateType]="productState.stateType">
                        </product-workflow-icon>
                        
                        <span [innerHtml]="productState.name | highlight: productStateControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </form>
          </mat-card-content>
        </mat-card>
        
    </div>
    <mat-card class="contrast">
        <mat-card-content>
            <div class="filter" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                  <mat-label>Search all {{ this.totalCount }} products</mat-label>
                  <input matInput type="text" name="searchTerm" placeholder="Search {{ this.totalCount }} products"
                      [(ngModel)]="searchTerm"
                      (ngModelChange)="debounceSearchTermChanged()"
                      (keyup.esc)="searchTerm=''; searchTermChanged()">
                  <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; searchTermChanged()">
                      <mat-icon>close</mat-icon>
                  </button>
              </mat-form-field>

              <div *ngIf="isSituUser">
                <mat-slide-toggle [(ngModel)]="enabledProductsFilter" (change)="onEnabledProductsFilter()">Enabled Products</mat-slide-toggle>
              </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="contrast" *ngIf="multiSelect">
        <mat-card-content>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div fxLayoutAlign="start center" fxLayoutGap="20px">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <button mat-icon-button color="accent" *ngIf="!hasSelectedAllProducts()" (click)="selectAllProducts(true)" matTooltip="Select All">
                    <mat-icon>select_all</mat-icon>
                  </button>
                  <button mat-icon-button color="accent" *ngIf="hasSelectedAllProducts()" (click)="selectAllProducts(false)" matTooltip="Deselect All">
                    <mat-icon>deselect</mat-icon>
                  </button>
                  {{ getSelectedProductCount() }} Selected {{ pluralize("Product", getSelectedProductCount()) }}.
                </div>

                <button mat-flat-button color="basic" (click)="loadAllProducts()" [disabled]="!hasMoreProductsToShow()">
                  Load All {{ this.totalCount }} Products
                </button>
              </div>

              <div>
                <button mat-flat-button color="primary" (click)="chooseSelectProducts()" [disabled]="getSelectedProductCount() === 0">
                  Select {{ pluralize("Product", getSelectedProductCount()) }}
                </button>
              </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-content>
            <div class="product-expanded-image-container" fxLayout="row wrap" fxLayoutAlign="center center">
                <ng-container *ngFor="let item of dataSource">
                    <thumb-product-card
                        [item]="item"    
                        [isSituUser]="isSituUser"
                        [isAdmin]="isAdmin"
                        [isExternalProductContractorUser]="isExternalProductContractorUser"
                        [isCompanyProductPublisherUser]="isCompanyProductPublisherUser"
                        [selectedCompanyId]="selectedCompany?.id"
                        [isCatalog]="isCatalog"
                        [searchTerm]="searchTerm"
                        [canExpandImage]="isCatalog"
                        (click)="onSelectProduct(item); $event.stopPropagation()"
                        [situView]="SituViewUrl"
                        [selected]="isSelectedProduct(item)"
                        [productTypeColor]="getProductTypeColor(item?.productTypeId)"
                        [productTypeName]="getProductTypeName(item?.productTypeId)"
                        [companyName]="getCompanyName(item?.companyId)"
                        [companyLogo]="getCompanyLogo(item?.companyId)"
                        (filterCompanyId)="selectCompanyByProduct($event)"
                        (filterProductTypeId)="selectProductTypeByProduct($event)"
                        (shareSituLink)="share($event)"
                        (createPreview)="getPreview($event)"
                        (productDownloadRequest)="onProductDownloadRequest($event)">
                    </thumb-product-card>
                </ng-container>
                <div *ngIf="!loading && !dataSource?.length && dataSource.length === 0">
                  No Products Found...
                </div>
                <div #showMoreProductsMarker fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
                    <button *ngIf="hasMoreProductsToShow()" mat-flat-button color="accent" (click)="showMoreProducts()" [disabled]="loading"> {{ loading ? "Loading" : "Show" }} more products</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>

  